
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    // export class PsDiscCouponTypeItemDialog extends Serenity.EntityDialog<PsDiscCouponTypeItemRow, any> {
        export class PsDiscCouponTypeItemDialog extends Serenity.Extensions.GridEditorDialog<PsDiscCouponTypeItemRow> {
        protected getFormKey() { return PsDiscCouponTypeItemForm.formKey; }
        // protected getIdProperty() { return PsDiscCouponTypeItemRow.idProperty; }
        protected getLocalTextPrefix() { return PsDiscCouponTypeItemRow.localTextPrefix; }
        protected getNameProperty() { return PsDiscCouponTypeItemRow.nameProperty; }
        protected getService() { return PsDiscCouponTypeItemService.baseUrl; }
        // protected getDeletePermission() { return PsDiscCouponTypeItemRow.deletePermission; }
        // protected getInsertPermission() { return PsDiscCouponTypeItemRow.insertPermission; }
        // protected getUpdatePermission() { return PsDiscCouponTypeItemRow.updatePermission; }

        protected form = new PsDiscCouponTypeItemForm(this.idPrefix);

        private pass: string

        public get Pass(): string { return this.pass }
        set Pass(value: string) { this.pass = value; }

        protected afterLoadEntity() {
            super.afterLoadEntity();
               
            if (this.isNew()) {
                this.form.DiscCouponType.value = this.pass                
            }
            
        }

    }
}